/* V43 §5 — „RASK SAVO MUZIKINĮ" skirtukai.
   Trys režimai gyvena vienoje sekcijoje kaip snippet'ai. game-finder ir mz-shelf
   moduliai veikia be pakeitimų. */
(function () {
  'use strict';

  /* V43 §5: DOM „įsivaikinimo" nebėra. Trys panelės renderinamos
     serveryje (recommender-first / -owned / -gift snippet'ai), todėl
     šiam moduliui liko tik skirtukų perjungimas. */

  function activate(root, key) {
    root.querySelectorAll('[data-fyg-tab]').forEach(function (b) {
      var on = b.dataset.fygTab === key;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-fyg-panel]').forEach(function (p) {
      p.hidden = p.dataset.fygPanel !== key;
    });
  }

  function Wrapper(root) {
    /* V73 · PERF-001 — IDEMPOTENT INIT.
       `init()` kviečiamas ir per DOMContentLoaded, ir per
       `shopify:section:load`. Be šios apsaugos tas pats elementas
       theme editoriuje inicializuojamas kartotinai: dubliuojasi
       listeneriai, o kai kur ir tinklo užklausos. Vienas elementas —
       viena inicializacija. */
    if (root.dataset.fygReady === '1') return;
    root.dataset.fygReady = '1';

    if (root._fyg) return;
    root._fyg = true;

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fyg-tab]');
      if (!b || !root.contains(b)) return;
      activate(root, b.dataset.fygTab);
    });

    /* Klaviatūra: rodyklės tarp skirtukų */
    root.addEventListener('keydown', function (e) {
      var b = e.target.closest('[data-fyg-tab]');
      if (!b) return;
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fyg-tab]'));
      var i = tabs.indexOf(b);
      var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      next.focus();
      activate(root, next.dataset.fygTab);
      e.preventDefault();
    });

    /* Jei žmogus jau pažymėjo turimus žaidimus, atidarome „Jau turiu" skirtuką */
    try {
      var owned = JSON.parse(localStorage.getItem('mz_owned_full_games_v2'));
      if (Array.isArray(owned) && owned.length) activate(root, 'owned');
    } catch (e) {}
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-fyg]').forEach(Wrapper);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function () { init(document); });
  if (document.readyState !== 'loading') init(document);
})();
